export default function autHeader() {
  return {
    Authorization: `Bearer ${localStorage.getItem('smb_access_token')}`
  }
}
